import { connect } from 'react-redux';
import EstimateModal from './EstimateModal';
import { closeEstimateModal, openEstimateModal } from './estimateModalActions';

function mapStateToProps(state) {
  return {
    isOpen: state.estimateModal.isOpen,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onCloseEstimateModal: () => dispatch(closeEstimateModal()),
    openEstimateModal: e => dispatch(openEstimateModal(e)),
  };
}


const EstimateModalContainer = connect(mapStateToProps, mapDispatchToProps)(EstimateModal);
export default EstimateModalContainer;
